<template>
  <div class="msgtypeCard">
    <div class="box_File">
      <div class="box_File_top">
        <div class="box_File_left">
          <div class="left_img">
            <img
              :class="items.msgtype === 'card' ? 'card_img' : 'all_img'"
              :src="items.msgtype === 'card' ? items.content.avatar : g_imgSrc.dialogueIcon"
            />
          </div>
        </div>
        <div class="box_File_right">
          <!-- 日程/个人名片 -->
          <h3 class="calendar_h3" v-if="items.msgtype === 'calendar' || items.msgtype === 'card'">
            {{ items.content.corpname | ellipsis }}
          </h3>
          <!-- 待办 -->
          <div v-if="items.msgtype === 'todo'">
            <h3 class="todo_h3">{{ items.content.title }}</h3>
            <p class="todo_p">{{ items.content.content }}</p>
          </div>
          <!-- 投票 -->
          <div v-if="items.msgtype === 'vote'">
            <h3 class="todo_h3">{{ items.content.votetitle }}</h3>
            <p class="todo_p">"{{ items.from_name }}"邀请大家参与投票</p>
          </div>
          <!-- 表格 -->
          <div v-if="items.msgtype === 'collect'">
            <h3 class="todo_h3">{{ items.content.title }}</h3>
            <p class="todo_p">"{{ items.content.creator }}"邀请大家填写表格</p>
          </div>
          <!-- 文档 -->
          <div v-if="items.msgtype === 'docmsg'">
            <h3 class="Docmsg_h3">{{ items.content.title | ellipsis }}</h3>
            <p class="Docmsg_p">文档</p>
          </div>
          <!-- 文件消息 -->
          <div v-if="items.msgtype === 'file'">
            <h3 class="file_h3">{{ items.file_names | ellipsis }}</h3>
          </div>
          <!-- 会议 -->
          <div v-if="items.msgtype === 'meeting'">
            <h3 class="meeting_h3">{{ items.content.topic | ellipsis }}</h3>
            <p class="meeting_p">会议号：{{ items.content.meetingid | ellipsis }}</p>
          </div>
        </div>
        <!-- 日程/个人名片 -->
        <div class="card_name" v-if="items.msgtype === 'calendar' || items.msgtype === 'card'">
          {{ items.content.username }}
        </div>
        <!-- 会议 -->
        <div class="card_name" v-if="items.msgtype === 'meeting'">
          组织者：{{ items.content.remarks }}
        </div>
      </div>
      <div class="card_title" v-if="items.msgtype !== 'file' && items.msgtype !== 'docmsg'">
        {{
          items.msgtype === 'calendar'
            ? '日程'
            : items.msgtype === 'card'
            ? '个人名片'
            : items.msgtype === 'todo'
            ? '待办'
            : items.msgtype === 'vote'
            ? '投票'
            : items.msgtype === 'collect'
            ? '表格'
            : items.msgtype === 'meeting'
            ? '腾讯会议'
            : ''
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  filters: {
    ellipsis(value) {
      const len = value.length;
      if (!value) return '';
      if (value.length > 24) {
        return `${value.substring(0, 14)}...${value.substring(len - 7, len)}`;
      }
      return value;
    },
  },
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
.msgtypeCard {
  width: 258px;
  padding: 0 12px;
  box-sizing: border-box;
  .box_File {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
    background: #ffffff;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    .box_File_left {
      width: 35%;
      .left_img {
        width: 42px;
        height: 42px;
        background: #2f96ff;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        .card_img {
          width: 100%;
          font-size: 0;
          border-radius: 4px;
        }
        .all_img {
          width: 28px;
          font-size: 0;
          border-radius: 4px;
        }
      }
    }
    .box_File_right {
      text-align: right;
      width: 65%;
      .calendar_h3 {
        font-size: 14px;
        color: #303133;
        line-height: 24px;
        word-break: break-all;
      }
      .todo_h3 {
        font-size: 14px;
        color: #303133;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .todo_p {
        font-size: 12px;
        color: #909399;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .Docmsg_h3 {
        font-size: 14px;
        color: #303133;
        line-height: 22px;
        word-break: break-all;
      }
      .Docmsg_p {
        font-size: 12px;
        color: #909399;
        line-height: 20px;
      }
      .file_h3 {
        font-size: 14px;
        color: #303133;
        line-height: 24px;
        word-break: break-all;
      }
      .meeting_h3 {
        font-size: 12px;
        color: #909399;
        line-height: 24px;
        word-break: break-all;
      }
      .meeting_p {
        font-size: 12px;
        color: #909399;
        line-height: 24px;
        word-break: break-all;
      }
    }
  }
  .box_File_top {
    padding: 15px 15px 0;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    box-sizing: border-box;
  }
  .card_name {
    width: 100%;
    line-height: 28px;
    font-size: 16px;
    color: #303133;
    text-align: right;
    height: 28px;
  }
  .card_title {
    width: 100%;
    line-height: 22px;
    font-size: 10px;
    color: #909399;
    text-align: right;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    padding: 0 15px;
    box-sizing: border-box;
  }
}
</style>
